export default "__VITE_ASSET__354ebf2a__"